import * as angular from 'angular';
export class Controller {

    /** @ngInject */
    constructor(
        $state,
        $uibModal,
        Alert,
        UserSettingsService,
    ) {
        this.$state=$state;
        this.$uibModal=$uibModal;
        this.Alert=Alert;
        this.UserSettingsService=UserSettingsService;

    }

    $onInit() {
        this.newSettings = angular.copy(this.userSettings);
        this.setDisplayNaming = null;
    }

    cancelSettings(){
        this.newSettings = angular.copy(this.userSettings);
    }
    confirmProcess(){
        this.$uibModal
            .open({
                component: 'companyUserDirectoriesSaaspassUsersUserSettingsConfirm',
                resolve: {
                    companyId: () => this.companyId,
                    setDisplayNaming: () => this.setDisplayNaming,
                },
            }).result
            .then(() => {
                return this.Alert('success', 'company.user-directories.saaspass-users.user-settings.successMessage');
            })
    }

    editRecoverySettings() {
        this.UserSettingsService.setAdminSettings(this.companyId,this.newSettings)
            .then(() => {
                this.Alert('success', 'company.user-directories.saaspass-users.user-settings.successMessage')
                this.userSettings = angular.copy(this.newSettings);
            });

    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/all-users/user-settings/user-settings.controller.js